import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { AppStateService } from '../../mtp-common/services/state';

@Injectable({
    providedIn: 'root',
})
export class TenantUnsetGuardService implements CanActivate {
    private readonly appState = inject(AppStateService);
    private readonly router = inject(Router);

    public canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean | UrlTree {
        if (this.appState.loggedInWithTenant.value) {
            let targetPage = 'map';
            if (this.appState.returnUrl.value) {
                // If there is a return URL, navigate to it.
                const returnUrl = this.appState.returnUrl.value;
                this.appState.returnUrl.value = null;

                targetPage = returnUrl;
            }

            return this.router.createUrlTree([targetPage]);
        } else {
            return true;
        }
    }
}
